"use client";

import { useEffect, useRef } from "react";
import { trackViewHomepage } from "@/app/lib/tracking";

export default function HomepageTracker() {
  const hasTrackedRef = useRef(false);

  useEffect(() => {
    if (!hasTrackedRef.current) {
      hasTrackedRef.current = true;
      trackViewHomepage({
        trigger_source: "homepage",
      });
    }
  }, []);

  return null;
}
